export default __webpack_public_path__ + "static/museo-sans-bold-c3408a8de4330ef07d94696c00c61685.woff";